import FooterTextItem from "./FooterTextItem";

export default FooterTextItem;
